const SIGN_OUT_SUCCESS = "authentication/SIGN_OUT_SUCCESS";
const SIGN_OUT_START = "authentication/SIGN_OUT_START";
const SIGN_IN_SUCCESS = "authentication/SIGN_IN_SUCCESS";

export default {
  SIGN_OUT_START,
  SIGN_OUT_SUCCESS,
  SIGN_IN_SUCCESS
};
